import { useBranding } from "../hooks/useBranding";

/**
 * The only place in the app that renders a product logo or wordmark.
 *
 * When PRODUCT_LOGO_URL is unset the wordmark stands alone — deliberately,
 * so an unbranded deployment reads as intentional rather than broken.
 */
export function BrandMark({ height = 18 }: { height?: number }) {
  const { productName, productLogoUrl } = useBranding();
  return (
    <span className="brand" style={{ display: "flex", alignItems: "center" }}>
      {productLogoUrl ? (
        <img
          src={productLogoUrl}
          alt={productName}
          style={{ height, width: "auto", marginRight: 8, display: "block" }}
        />
      ) : null}
      {/* The wordmark: the name in letter-spaced capitals, with the OS set
          apart. "WORKFORCEOS" run together is a keyboard mash; "WORKFORCE OS"
          is a mark. In running text the name stays WorkForceOS. */}
      <span className="product">{productName.toUpperCase().replace(/OS$/, " OS")}</span>
    </span>
  );
}
